
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 628.254 613.516"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M99.777 446.086c-6.699 12.031-12.031 30.133-12.031 41.539 0 2.648 0 6.016.656 10.688L4.676 354.32C1.996 349.648 0 342.945 0 336.906c0-6.047 1.996-13.398 4.676-18.078L44.871 248.5 0 223.07l146.016-2.703L217 348.281l-45.527-26.117-71.696 123.922zM164.09 40.227c12.715-22.125 33.496-34.18 58.926-34.18 27.48 0 48.918 12.742 64.312 38.828l22.777 38.172-79.051 136.664-127.914-74.352 60.95-105.132zm9.351 521.718c-38.172 0-69.645-31.477-69.645-69.648 0-10.719 4.703-28.82 11.402-40.195l21.41-38.172h158.758v148.016H173.441zM300.727 36.18C290.691 18.789 277.293 6.703 261.215 0h164.746c14.738 0 26.113 6.047 32.84 17.445l40.852 69.648 44.191-26.141-71.016 127.281-145.305-2.047 44.871-25.43L300.727 36.18zM554.59 415.273c20.07 0 36.832-5.359 50.887-16.055l-83.07 144.648c-6.699 11.375-18.73 18.078-32.789 18.078h-78.395v51.57L336.219 488.28l75.004-125.266v52.258H554.59zm64.258-120.562c6.043 10.719 9.406 22.094 9.406 34.156 0 24.117-15.422 49.57-36.832 61.602-10.062 5.391-24.145 8.75-38.172 8.75h-44.242l-79-136.664 127.918-73.008 60.922 105.164z"}})])
          )
        }
      }
    